import { render } from "./thankyoumail.vue?vue&type=template&id=3f51f872&scoped=true"
import script from "./thankyoumail.vue?vue&type=script&lang=js"
export * from "./thankyoumail.vue?vue&type=script&lang=js"

import "./thankyoumail.vue?vue&type=style&index=0&id=3f51f872&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f51f872"]])

export default __exports__